<script setup>
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import AppLayout from '@/layouts/AppLayout.vue';
import HomeFeatureSection1 from '@components/home/FeatureSection1.vue'
import HomeFeatureSection2 from '@components/home/FeatureSection2.vue'
import HomeFeatureSection3 from '@components/home/FeatureSection3.vue'
import HomeFeatureSection4 from '@components/home/FeatureSection4.vue'
import HomeHeadingSection from '@components/home/HeadingSection.vue'
import SeparatorBorder from '@components/SeparatorBorder.vue'
import SubscriptionCallout from '@components/subscription/SubscriptionCallout.vue'
import AppDownloadBanner from '@components/app/AppDownloadBanner.vue'

const page = usePage()
// Shown only when the marketing flag is on, so the subscription can be promoted
// on the landing silently first (SUB-MVP-65/67).
const marketingEnabled = computed(() => !!page.props.features?.subscription_marketing)
// App-download banner, its own flag (SUB-MVP-66).
const appBannerEnabled = computed(() => !!page.props.features?.app_download_banner)
</script>

<template>
  <Suspense>
    <AppLayout title="Home">
      <div class="px-6 py-12 mb-16 bg-white sm:py-32 lg:px-8 isolate rounded-lg shadow">
        <HomeHeadingSection/>
        <template v-if="marketingEnabled">
          <SeparatorBorder/>
          <SubscriptionCallout/>
        </template>
        <SeparatorBorder/>
        <HomeFeatureSection1/>
        <SeparatorBorder/>
        <HomeFeatureSection2/>
        <SeparatorBorder/>
        <HomeFeatureSection3/>
        <SeparatorBorder/>
        <HomeFeatureSection4/>
        <template v-if="appBannerEnabled">
          <SeparatorBorder/>
          <AppDownloadBanner/>
        </template>
      </div>
    </AppLayout>
  </Suspense>
</template>
